import React, {useEffect}  from "react";
// import "./Class/batches.css";





function Meanings(props) {


    
    

  
   
 


    


        return (
            
            <div className="mypopup-box">
      <div className="mybox">
       
        
       <label>
       Meaning: {props.meaning}
       
      </label>
         {<button className= "popupbutton" onClick={props.closewindow}>OK</button> }
     

      </div>
       
    </div>
          );
      


}

export default Meanings;
